import React from 'react';
import RichTextUndoRedoButton from "./rich-text-undo-redo-button.jsx";
import RichTextHeadingDropdownMenu from "./rich-text-heading-dropdown-menu.jsx";
import RichTextListDropdownMenu from "./rich-text-list-dropdown-menu.jsx";
import RichTextActionButton from "./rich-text-action-button.jsx";
import RichTextAlignButton from "./rich-text-align-button.jsx";
import "../../css/style-rich-text.css"

const RichTextToolbar = ({wrapperClass = "", endActions, children}) => {
    return (
        <div className={["rich-text-toolbar print:hidden", wrapperClass].join(" ")} role="toolbar">
            { children }

            <div className="toolbar-group">
                <RichTextUndoRedoButton action="undo" disabled={false}/>
                <RichTextUndoRedoButton action="redo" disabled={false}/>
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextHeadingDropdownMenu levels={[1, 2, 3, 4, 5, 6]}/>
                <RichTextListDropdownMenu types={["bulletList", "orderedList"]} />
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextActionButton type="bold" />
                <RichTextActionButton type="italic" />
                <RichTextActionButton type="underline" />
                <RichTextActionButton type="strike" />
            </div>

            <div className="rich-text-separator" />

            <div className="toolbar-group">
                <RichTextAlignButton align="left"/>
                <RichTextAlignButton align="center"/>
                <RichTextAlignButton align="right"/>
                <RichTextAlignButton align="justify"/>
            </div>

            {
                endActions &&
                <>
                    <div className="rich-text-separator"/>

                    <div className="toolbar-group">
                        {endActions}
                    </div>
                </>
            }
        </div>
    );
};

export default RichTextToolbar;